import { render, staticRenderFns } from "./ProfileCardList.vue?vue&type=template&id=f45a8c8e&scoped=true&"
import script from "./ProfileCardList.vue?vue&type=script&lang=js&"
export * from "./ProfileCardList.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardList.vue?vue&type=style&index=0&id=f45a8c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45a8c8e",
  null
  
)

export default component.exports